import {useContext} from "react";
import {OmniContext} from "@/OmniContext.ts";
import omni_wordmark_black from "../../res/omni_wordmark_black.png"
import omni_wordmark_white from "../../res/omni_wordmark_white.png";
import User from "../../model/User.ts";
import {Burger, Button, Group, Menu, Text, useMantineColorScheme} from "@mantine/core";
import {
    IconBrandWindows,
    IconChevronDown, IconKeyOff, IconReload, IconSearch, IconSettings,
    IconSpyOff, IconUser, IconUserCircle
} from "@tabler/icons-react";
import {Link, useNavigate} from "react-router-dom";
import OmniFetchTS from "@/util/OmniFetchTS.js";
import TooltipActionIcon from "@/components/TooltipActionIcon.js";
import { openSpotlight } from "@mantine/spotlight"
import TimeClock from "@/components/OmniTitleBar/TimeClock.tsx";
import {useLocalStorage} from "@mantine/hooks";
import {LAST_SECURITY_KEY_VERIFICATION_TIMESTAMP_LOCAL_STORAGE_PROPS} from "@/util/constants.ts";
import {DateTime} from "luxon";

function OmniTitleBar({opened, toggleOpened}: {opened: boolean, toggleOpened: () => void}) {
    const context = useContext(OmniContext)
    const navigate = useNavigate()
    let e = context.environment
    const {colorScheme} = useMantineColorScheme()
    let activeLogo;
    activeLogo = omni_wordmark_white
    if (colorScheme == "light") {
        activeLogo = omni_wordmark_black
    }
    const [lastVerificationTimestamp, setLastVerificationTimestamp] = useLocalStorage(LAST_SECURITY_KEY_VERIFICATION_TIMESTAMP_LOCAL_STORAGE_PROPS)
    const lastVerification = DateTime.fromISO(lastVerificationTimestamp ?? "")


    return <Group justify={"space-between"} align={"center"} h={"60"} pl={"md"} pe={"md"}>
        <Group align={"center"}>
            <Burger
                opened={opened}
                onClick={toggleOpened}
                size={"sm"}
            />
            <Link to={"/"} style={{textDecoration: "none"}}>
                <Group align={"center"}>
                    <img alt={"Omni"} src={activeLogo} height={30}/>
                    {e && <Group align={"end"} gap={"xs"}>{e.environmentName !== "" ? <Text size={"xl"} c={e.environmentColor} fw={"bolder"}>({e.environmentName})</Text> : ""}</Group>}
                </Group>
            </Link>
        </Group>
        <Group gap={10}>
            <TimeClock/>
            <TooltipActionIcon label={"Omni Global Search (Ctrl+K)"} actionIconProps={{variant: "subtle"}} size={"lg"} onClick={openSpotlight}>
                <IconSearch/>
            </TooltipActionIcon>
            {context.user &&
                <Menu withinPortal={false}>
                    <Menu.Target>
                        <Button variant={context.user.impersonated ? "light" : "subtle"} color={context.user.impersonated ? "red" : undefined} rightSection={<IconChevronDown/>} ps={"xs"} pe={"xs"}>
                            <IconUserCircle/>{context.user.impersonated && " (impersonating " + context.user.name + ")"}
                        </Button>
                    </Menu.Target>
                    <Menu.Dropdown>
                        <Menu.Item leftSection={<IconUser/>} onClick={() => navigate("/users/me")}>
                            View My Profile
                        </Menu.Item>
                        {context.user && context.user.hasSystemPermissionByName("Config", "Admin") &&
                            <Menu.Item leftSection={<IconSettings/>} onClick={() => navigate("/config")}>Config</Menu.Item>
                        }
                        <Menu.Item leftSection={<IconReload/>} onClick={() => {
                            User.getActiveUser(true).then((user) => {
                                if (context.setUser && user) {
                                    context.setUser(user)
                                }
                            })
                        }}>
                            Reload Permissions
                        </Menu.Item>
                        {(lastVerification.diffNow("minutes").minutes > -30) && <Menu.Item leftSection={<IconKeyOff/>} onClick={() => {OmniFetchTS("/api/v1/security_keys/end_session", {method: "DELETE"}).then((json) => {
                            if (json.success) {
                                setLastVerificationTimestamp("")
                            }
                        })}}>End 2FA Session</Menu.Item>}
                        {context.user.impersonated ?
                            <Menu.Item color={"violet"} leftSection={<IconSpyOff/>} onClick={() => {OmniFetchTS("/api/v1/users/impersonate", {method: "DELETE"}).then((json) => {
                                if (json.success) {
                                    window.location.reload()
                                }
                            })}}>
                                Stop Impersonation
                            </Menu.Item> :
                            <Menu.Item leftSection={<IconBrandWindows/>} onClick={() => {window.location.assign("/logout")}}>
                                Logout
                            </Menu.Item>
                        }
                    </Menu.Dropdown>
                </Menu>
            }
        </Group>
    </Group>
}
export default OmniTitleBar